import { Socket } from '@nutshell/core';

class VueSocket extends Socket {

    /**
     * Add function to the list of listeners. If the given eventname is equal to the received eventname, the function will be triggered.
     *
     * @param {String} event
     * @param {Function} listener
     * @param {String} cuid
     */
    on(event, listener, cuid) {

        if ( typeof listener == 'function' ) {

            this.listeners.push({
                event,
                listener,
                cuid
            });
        }
    }

    /**
     * Remove event listeners of component
     *
     * @param {String} cuid
     */
    clear(cuid) {

        const removal = [];

        /**
         * Collect all event for removal based on the component.
         */
        this.listeners.forEach( (listener, index) => {

            if ( listener.cuid == cuid ) {
                removal.unshift(index);
            }
        });

        /**
         * Remove all listeners based on collected indexes. Always remove the biggest index first.
         */
        removal.forEach( (index) => {
            this.listeners.splice(index,1);
        });
    }

}

/**
 * Installing the VueSocket as a plugin for Vue
 */
 export default {
	install: (app, options) => {
        options ??= {};

        let _socket = new VueSocket(options);
        
        app.mixin({
            created() {

                this.$options.cuid = Math.random().toString(36).substring(2, 12);
                
                if ( this.$options.events && typeof this.$options.events == 'object' ) {

                    const events = Object.keys(this.$options.events);
    
                    events.forEach( ( event ) => {    
                        if ( typeof this.$options.events[event] == 'function' ) {
                            _socket.on(event, this.$options.events[event],  this.$options.cuid);
                        }    
                    });
                }
            },
            beforeUnmount() {
                
                if (  this.$options.cuid ) {
                    _socket.clear( this.$options.cuid );
                }
            }
        });

        app.config.globalProperties.$socket = _socket;
	}
}
